import { BaseItem, PhoneNumberKind } from '../common';

export enum Kind {
  Sms = 'SMS',
  Email = 'EMAIL',
  Voice = 'VOICE',
}

export enum Publisher {
  Twilio = 'TWILIO',
  Sendgrid = 'SENDGRID',
}

export enum Source {
  Broadcast = 'BROADCAST',
  DigitalCheckIn = 'DIGITAL_CHECK_IN',
  Fingerprint = 'FINGERPRINT',
  GroupedAppointmentBookingConfirmation = 'GROUPED_APPOINTMENT_BOOKING_CONFIRMATION',
  Manual = 'MANUAL',
  Previsit = 'PREVISIT',
  Test = 'TEST',
}

export enum Reason {
  AppointmentConfirmation = 'APPOINTMENT_CONFIRMATION',
  AuthCode = 'AUTH_CODE',
  ContactConfirmation = 'CONTACT_CONFIRMATION',
  VisitInitial = 'VISIT_INITIAL',
  VisitReminder1 = 'VISIT_REMINDER_1',
  VisitReminder2 = 'VISIT_REMINDER_2',
  PaymentConfirmation = 'PAYMENT_CONFIRMATION',
  PaymentReceipt = 'PAYMENT_RECEIPT',
  StaticLinkInitial = 'STATIC_LINK_INITIAL',
  StaticLinkReminder1 = 'STATIC_LINK_REMINDER_1',
  StaticLinkReminder2 = 'STATIC_LINK_REMINDER_2',
  // DEPRECATED
  FirstNotification = 'FIRST_NOTIFICATION',
  Reminder = 'REMINDER',
}

type PatientKey =
  | { patientId: string; provisionalPatientId: null }
  | { patientId: null; provisionalPatientId: string };

type BaseValues = PatientKey & {
  previsitFormSetId: string | null;
  content: string;
  kind: Kind;
  publisher: Publisher;
  publisherErrorCode: string | null;
  publisherReferenceId: string | null;
  source: Source;
  reason: Reason | string;
  phoneNumber: string | null;
  phoneNumberKind: PhoneNumberKind | null;
  email: string | null;
  emailUnsubscribeCode: string | null;
  from: string | null;
  success: boolean | null;
  failureReason: string | null;
  notificationConfigId: string | null;
  notificationContentId: string | null;
  encounterId: string | null;
};

export type PatientNotification = BaseValues & BaseItem;
